import { CREATE_HSNCODE, GET_HSNCODE, HSNCODE_REQUEST, DELETE_HSNCODE, UPDATE_HSNCODE, HSNCODE_REQUEST_FAILURE } from  "../types"

const initialState = {
    hsnCodes: [],
    loading: false,
    error: null,
  };

  const hsncodeReducer = (state = initialState, action) => {
    switch (action.type) {
      case HSNCODE_REQUEST: {
        return {
          ...state,
          loading: true,
          error: null
        }
      }
      case GET_HSNCODE: {
        return {
          ...state,
          hsnCodes: [...action.payload],
          loading: false,
          error: null
        }
      }
      case CREATE_HSNCODE:
        return {
          ...state,
          hsnCodes: [action.payload, ...state.hsnCodes],
          loading: false,
          error: null
        };
      case UPDATE_HSNCODE:
        const hsncodesData = state.hsnCodes.slice(0);
        const uIndex = hsncodesData.findIndex((data) => data.id === action.payload.id);
        hsncodesData.splice(uIndex, 1, { ...action.payload.data });
        return {
          ...state,
          hsnCodes: [ ...hsncodesData ],
          loading: false,
          error: null
        };
      case DELETE_HSNCODE:
        const hsnCodes = state.hsnCodes?.slice(0);
        const index = hsnCodes.findIndex((data) => data.id === action.id);
        if (index > -1) {
          hsnCodes.splice(index, 1);
        }
        return {
          ...state,
          hsnCodes: [...hsnCodes],
          loading: false,
          error: null
        }
      case HSNCODE_REQUEST_FAILURE: {
        return {
          ...state,
          loading: false,
          error: action.error
        }
      }
      default:
        return state;
    }
  };

  export default hsncodeReducer